import {getMobilePhoneClearValue} from "./inputs";

const regEmail = /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,}$/i;
const regNameRus = /^[А-Яа-яЁё\-'\s]+$/i;
const regDate = /(\d{2}\.\d{2}\.\d{4})/;
const regNum = /^\d+$/;

/**
 * Валидация формы
 * @param {HTMLElement}  $form - html объект формы
 * @param {Boolean} showError - показывать ошибки или нет
 * @return {boolean} результат проверки формы
 */
function validateForm($form, showError = true) {
    let error = 0;

    let $fields = $form.find('input.validate, textarea.validate, select.validate');

    $fields.each(function () {
        if (!validateField($(this), showError)) {
            error++;
        }
    });

    if (error > 0) return false;

    return true;
}

/**
 * Валидация поля
 * @param {HTMLElement} $field - поле для валидации
 * @param {Boolean} showError - показывать ошибки или нет
 * @return {boolean} результат проверки поля
 */
function validateField($field, showError = true) {
    if (!$field.hasClass('validate')) return true;
    if ($field.hasClass('validate-disabled')) return true;

    const $fieldBlock = $field.parents('.field');
    const $errorMessage = $fieldBlock.parents('.input-block').find('.error-message');
    const $helperMessage = $fieldBlock.parents('.input-block').find('.helper-message');

    let error = 0;
    let message = '';
    let helper_message = '';

    let val = $.trim($field.val());
    const valLength = +$field.attr('maxlength') || 0;
    const plh = $field.attr('data-placeholder');
    const type = $field.attr('data-validate');
    const errorMessage = $field.attr('data-error_message');

    const mobilePhoneInvalidFirstSymbols = ['0', '1', '2', '7'];

    let firstSymbol = val[0] || '';

    switch (type) {
        //обязательно для заполнения
        case 'required':
            if (!val) {
                error++;
                message = 'Поле обязательно для заполнения';
            }
            break;

        //радио кнопки - обязательно для выбора
        case 'required_checkbox_radio':
            if (!+$field.find('input:checked').length) {
                error++;
                message = 'Выберите хотя бы 1 вариант';
            }
            break;

        // число
        case 'number':
            val = val + '';
            if (
                !val ||
                val.search(regNum) === -1 ||
                (valLength && valLength !== val.length)
            ) {
                error++;
                message = 'Только цифры';
            }
            break;

        //номер телефона
        case 'mobile_phone':
            val = getMobilePhoneClearValue($field);
            firstSymbol = val[0];

            if (!val || val.search(regNum) === -1 || val.length !== 10 ||
                mobilePhoneInvalidFirstSymbols.includes(firstSymbol)) {
                error++;
                message = 'Укажите корректный номер телефона';
            }
            break;

        // только русские буквы, для фио
        case 'rusfield':
            if (!val || val.search(regNameRus) === -1 || val.length > 50 || val.length < 2) {
                error++;
                message = 'Только русские буквы, до 50 символов';
            }
            break;

        case 'rusfield_empty':
            if (val) {
                if (val.search(regNameRus) === -1 || val.length > 50 || val.length < 2) {
                    error++;
                    message = 'Только русские буквы, до 50 символов';
                }
            }
            break;

        //денежный формат
        case 'money':
            val = val + '';
            if (!val || val.search(regNum) === -1) {
                error++;
                message = 'Только цифры';
            }
            break;

        //email
        case 'email':
            val = val.toLowerCase();
            if (!val || val.search(regEmail) === -1 || val.length > 50) {
                error++;
                message = 'Укажите корректный адрес электронной почты';
            }
            break;

        //email
        case 'email_empty':
            if (val) {
                val = val.toLowerCase();
                if (!val || val.search(regEmail) === -1 || val.length > 50) {
                    error++;
                    message = 'Укажите корректный адрес электронной почты';
                }
            }
            break;
    }

    // еслии задано кастомное сообщение об ошибке - выводим его
    if (errorMessage) message = errorMessage;

    if (helper_message) message = helper_message;

    //если поле заполнено не корректно
    //возвращаем

    if (error > 0) {
        if (showError) {
            if (helper_message) {
                $helperMessage.html(message);
            } else {
                $errorMessage.html(message);
            }

            $fieldBlock.removeClass('success').addClass('error');
            $fieldBlock.parents('.input-block').addClass('error');

        }

        return false;

    } else {
        $helperMessage.html('');
        $errorMessage.html('');
        $fieldBlock.removeClass('error').addClass('success');
        $fieldBlock.parents('.input-block').removeClass('error');
        return true;
    }
}

export {
    validateField,
    validateForm
}
